/// <amd-module name="Test/TestPlansHubRefresh/Pivots/AuthorPivot/Component/TestCasesTableItemProvider" />
import { ITestCaseItem } from "Test/TestPlansHubRefresh/Pivots/AuthorPivot/Redux/AuthorContracts";
import { ObservableArray } from "VSS/Core/Observable";
import { IListSelection } from "VSSUI/List";
import { ISelectionRange } from "VSSUI/Utilities/Selection";

export class TestCasesTableItemProvider {
    private _items: ObservableArray<ITestCaseItem>;

    constructor() {
        this._items = new ObservableArray<ITestCaseItem>();
    }

    public getTestCaseItems(testCases: ITestCaseItem[], selection?: IListSelection, filteredTestCases?: number[]): ObservableArray<ITestCaseItem> {
        // Clear the observable array if there are no test cases
        if (!testCases || testCases.length == 0) {
            this._items.removeAll();
            return this._items;
        }

        // store the indices of the items that the user may have selected in the table (used during paging where we render all items)
        const selectedIndices: number[] = [];
        if (selection && selection.value && selection.value.length > 0) {
            const length: number = selection.value.length;
            for (let i = 0; i < length; i++) {
                const selectionRange: ISelectionRange = selection.value[i];

                if (selectionRange) {
                    for (let j = selectionRange.beginIndex; j <= selectionRange.endIndex; j++) {
                        selectedIndices.push(j);
                    }
                }
            }
        }

        // clear all the items first
        this._items.removeAll();

        // if filteredTestCases is valid and there are no items in filtered test cases, return empty items so an empty table can render
        if (filteredTestCases && filteredTestCases.length === 0) {
            return this._items;
        }

        // testCases[] contains the stuff we want to render (covers both filtered and non-filtered cases)
        for (let i = 0; i < testCases.length; i++) {
            const item = {
                ...testCases[i],
                ...testCases[i].columnOptionValues
            };
            this._items.push(item);
        }

        // restore the selected indices so we maintain the user selected cases in the new render
        if (selection && selectedIndices && selectedIndices.length > 0) {
            for (const idx of selectedIndices) {
                selection.select(idx, 1, true);
            }
        }

        return this._items;
    }
}
